import { Button, Modal } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import './feedback.scss';
import { useEffect, useState } from 'react';
import toast, { NotifyType } from 'utils/toast';
import { FeedBackModel } from 'interface/FeedBack';
import { AppState } from 'interface/stateApp';
import { sendFeedBackResponse } from 'service/feedBackService';

interface FormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  updateData?: any;
  data?: FeedBackModel | null;
}

function FeedbackModal({ stateApp, setStateApp, data, updateData }: FormProps) {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [feedBack, setFeedBack] = useState<Partial<FeedBackModel>>({});

  useEffect(() => {
    if (data) {
      setFeedBack(data);
    }
  }, [data]);

  const { showFeedBack } = stateApp;

  const handleSubmit = async () => {
    console.log(feedBack);
    if (feedBack?.adminResponse === undefined || feedBack?.adminResponse === null) {
      toast(NotifyType.WARNING, 'Vui lòng nhập đủ thông tin');
      return;
    }
    sendFeedBackResponse(feedBack?.id, feedBack as FeedBackModel)
      .then((response) => {
        if (updateData) {
          toast(NotifyType.SUCCESS, 'Gửi phản hồi thành công!');
          updateData();
          setStateApp({ ...stateApp, showFeedBack: false });
        }
      })
      .catch((error) => {
        toast(NotifyType.ERROR, 'Có lỗi xảy ra!');
        setStateApp({ ...stateApp, showFeedBack: false });
      });
  };

  return (
    <>
      <Modal
        visible={showFeedBack}
        onCancel={() =>
          setStateApp({
            ...stateApp,
            showFeedBack: false,
          })
        }
        footer={[]}
        className="!rounded-full"
      >
        {/* Feedback Form */}
        <div className="space-y-4 rounded-lg feedback-container p-4">
          <div className="text-[24px] border-b border-gray-300 pb-2">
            <MailOutlined className="text-primary" /> Góp ý
          </div>
          <div>
            <label className="block text-primary mb-2">
              <span className="text-red-500">*</span>Loại góp ý
            </label>
            <div className="w-full custom-select">
              {feedBack?.feedBackType?.name}
            </div>
          </div>
          <div className="rounded-lg">
            <label className="block text-primary mb-2">
              {' '}
              <span className="text-red-500">*</span>Nội dung góp ý
            </label>
            <textarea
              placeholder="Điền nội dung góp ý của bạn tại đây"
              className="rounded-2xl w-full p-2 resize-none border border-[#919191] outline-none"
              rows={4}
              value={feedBack?.feedBackContent}
            />
          </div>
          {feedBack?.feedBackAttachments?.map((attachment) => (
            <div key={attachment.fileName} className="relative mt-4 inline-block">
              <div>
                <img src={attachment.filePath} alt={attachment.fileName} className="max-w-full h-auto rounded-md" />
              </div>
            </div>
          ))}
          <div className="rounded-lg">
            <label className="block text-primary mb-2">
              {' '}
              <span className="text-red-500">*</span>Phản hồi
            </label>
            <textarea
              placeholder="Điền nội dung góp ý của bạn tại đây"
              className="rounded-2xl w-full p-2 resize-none border border-[#919191] outline-none"
              rows={4}
              onChange={(e) => setFeedBack({ ...feedBack, adminResponse: e.target.value })}
              value={feedBack?.adminResponse}
            />
          </div>
          <Button
            key="submit"
            type="primary"
            className="bg-primary text-white rounded-full w-full py-4"
            onClick={handleSubmit}
          >
            Gửi góp ý
          </Button>
          ,
        </div>
      </Modal>
    </>
  );
}

export default FeedbackModal;
